import { HubFeature } from '@ats/api/cm';
import { LocDef, LocDefs, LocMap } from '@cm/core/localization';

const pathStart = 'Candidate|Program History|Add Other Achievement Form';

const sharedProperties: Pick<LocDef, 'shared' | 'htmlAllowed' | 'feature' | 'portal'> = {
	shared: false,
	htmlAllowed: false,
	feature: HubFeature.CandidateAccessLoginEmcOtherAchievements,
	portal: 'SP',
};

type LocNameStart = 'SPCandidateUpdateOtherAchievement';
export type SPCandidateUpdateOtherAchievementLocNames =
	| `${LocNameStart}Title`
	| `${LocNameStart}EditTitle`
	| `${LocNameStart}AddButton`
	| `${LocNameStart}UpdateButton`
	| `${LocNameStart}CancelButton`;

export const spCandidateUpdateOtherAchievement: LocDefs<SPCandidateUpdateOtherAchievementLocNames> = {
	SPCandidateUpdateOtherAchievementTitle: {
		defaultValue: 'Add Certification',
		description: 'Title for page to add a certification.',
		displayPath: `${pathStart}|Title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPCandidateUpdateOtherAchievementEditTitle: {
		defaultValue: 'Edit Certification',
		description: 'Title for page to edit a certification.',
		displayPath: `${pathStart}|Title`,
		displayType: 'Title',
		...sharedProperties,
	},
	SPCandidateUpdateOtherAchievementAddButton: {
		defaultValue: 'Add Certification',
		description: 'Button to add certification.',
		displayPath: `${pathStart}|Add Certification Button Tooltip`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPCandidateUpdateOtherAchievementUpdateButton: {
		defaultValue: 'Update Certification',
		description: 'Button to edit a certification.',
		displayPath: `${pathStart}|update Certification Button`,
		displayType: 'Button',
		...sharedProperties,
	},
	SPCandidateUpdateOtherAchievementCancelButton: {
		defaultValue: 'Cancel add certification',
		description: 'Button to cancel adding a new certification.',
		displayPath: `${pathStart}|Cancel Add Certification Button Tooltip`,
		displayType: 'Button',
		...sharedProperties,
	},
};

export type SPCandidateUpdateOtherAchievementLocType = LocMap<SPCandidateUpdateOtherAchievementLocNames>;
